// The whole of this app's shared state. Small enough for a reactive object,
// no Vuex. Shaped `{ state: {...} }` because the house bug-report module
// reads `store.state`, which keeps that file recognisably the same one
// Meal Hat, Movie Hat and Cinema Roll carry.
import { reactive } from 'vue';

export const store = reactive({
  state: {
    updateAvailable: false,
    appError: null,
    email: null,
    // Which hat the course is attached to (Meal Hat's database top key).
    hat: null,
    // What the person is doing, for a bug report to say so: 'home', 'lesson',
    // 'cooking', 'debrief'.
    activity: 'home'
  }
});

export const setUpdateAvailable = (value) => { store.state.updateAvailable = value; };
export const setAppError = (message) => { store.state.appError = message; };
export const setEmail = (email) => { store.state.email = email || null; };
export const setHat = (hat) => { store.state.hat = hat || null; };
export const setActivity = (activity) => { store.state.activity = activity; };
